import React from 'react';

/**
 * Composant LogoHeader - Affiche les 3 logos partenaires
 * Ordre: SOF Formation (gauche) | Cap Nord (centre) | FSE/UE (droite, plus grand)
 *
 * Projet financé par le FSE+ - L'ordre et la taille sont réglementaires
 * Version responsive : tailles réduites sur mobile pour éviter le débordement
 */
const LogoHeader = ({ className = '', showBackground = true }) => {
  return (
    <div className={`w-full ${showBackground ? 'bg-white border-b border-slate-200' : ''} ${className}`}>
      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
        <div className="flex items-center justify-between py-2 sm:py-3 gap-1 sm:gap-2">
          {/* SOF Formation - Gauche (petit) */}
          <div className="flex-shrink-0">
            <img
              src="/logos/sof-formation.jpg"
              alt="SOF Formation - Conseil et Formation"
              className="h-7 sm:h-9 md:h-10 w-auto object-contain"
              data-testid="logo-sof"
            />
          </div>

          {/* Cap Nord Martinique - Centre (petit) */}
          <div className="flex-shrink-0 mx-1 sm:mx-2 md:mx-4">
            <img
              src="/logos/cap-nord.png"
              alt="CAP Nord Martinique - Communauté d'Agglomération du Pays Nord Martinique"
              className="h-7 sm:h-9 md:h-10 w-auto object-contain"
              data-testid="logo-cap-nord"
            />
          </div>

          {/* FSE / Union Européenne - Droite (plus grand, détaché) */}
          <div className="flex-shrink-0 pl-1 sm:pl-4 md:pl-8 border-l-2 border-slate-200">
            <img
              src="/logos/fse-ue.png"
              alt="Cofinancé par l'Union européenne - FSE+"
              className="h-12 sm:h-16 md:h-24 w-auto object-contain"
              data-testid="logo-fse"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoHeader;
